// @contexts/DocumentList.context.tsx
import React, { createContext, useContext, ReactNode } from 'react';
import * as Option from "@utils/Option";
import type { DocumentMetadata } from "@ps-bridge/models/core/dataContracts";
import { useIoState } from '@utils/useIoState';
import type { OptionTs } from "@ps-bridge/interop";
import type { StateHandle } from "@ps-bridge/capabilitiesTypes";
import { requireContext } from '@contexts/requireContext';

export interface DocumentListContextType {
    availableDocuments: StateHandle<DocumentMetadata[]>;
}

const DocumentListContext = createContext<OptionTs<DocumentListContextType>>(Option.none());

export const DocumentListProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const availableDocuments = useIoState<DocumentMetadata[]>([]);
    const contextValue = Option.some({ availableDocuments });

    return <DocumentListContext.Provider value={contextValue}>{children}</DocumentListContext.Provider>;
};

export const useDocumentListContext = (): DocumentListContextType => {
    return requireContext(
        useContext(DocumentListContext),
        'useDocumentListContext must be used within a DocumentListProvider',
    );
};
